import React from "react";
import POSTMAN1 from "../../../assets/images/postman1.png";
import POSTMAN2 from "../../../assets/images/postman2.png";
import POSTMAN3 from "../../../assets/images/postman3.png";
import POSTMAN4 from "../../../assets/images/postman4.png";
import POSTMAN5 from "../../../assets/images/postman5.png";

// /document-api?i=postman
export default function Postman() {
  return (
    <>
              <h5 className="fw-bold">1. Prepare Your Certificate Files</h5>
              <p>You'll need both:</p>
              <ul>
                <li>
                  <b>certificate.pem</b> file for the public certificate
                </li>
                <li>
                  <b>private.key</b> file for the private key
                </li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={POSTMAN1}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h5 className="fw-bold">2. Open Postman Settings</h5>
              <ul>
                <li>Open Postman</li>
                <li>Click the Settings icon (⚙️ in the top right)</li>
                <li>Go to the Certificates tab</li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={POSTMAN2}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={POSTMAN3}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h5 className="fw-bold">3. Add Your Certificate</h5>
              <ul>
                <li>Click Add Certificate</li>
                <li>In Host, enter the domain or IP of the API </li>
                <li>
                  CRT file → select your <b>"certificate.pem"</b>
                </li>
                <li>
                  KEY file → select your <b>"private.key"</b>
                </li>
                <li>
                  Click <b>"Add"</b>
                </li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={POSTMAN4}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h5 className="fw-bold">
                4. Disable SSL Verification (local testing only)
              </h5>
              <p>
                Our API uses a publicly trusted certificate, so keep SSL
                verification <b>ON</b> when calling it. Only if you test against
                a self-signed certificate (e.g., localhost) you may need to
                disable SSL verification:
              </p>
              <ul>
                <li>Go to Settings → General</li>
                <li>Turn SSL certificate verification → OFF</li>
              </ul>
              <div className="w-100 rounded-3 px-3 py-2 my-3 bg-light">
                <img
                  alt="API"
                  src={POSTMAN5}
                  className="w-100 my-3"
                  style={{ maxWidth: 700 }}
                />
              </div>
              <h5 className="fw-bold">5. Test Your API</h5>
              <ul>
                <li>Open the request that requires the certificate</li>
                <li>
                  Send it — Postman will automatically pick the certificate
                  based on the Host you configured
                </li>
              </ul>
              <h5 className="fw-bold">6. Collection Variables</h5>
              <p>
                The requests use these variables:{" "}
                <code>{`{{url}}, {{client_id}}, {{client_secret}}, {{client_ref_id}}, {{x-apigw-api-id}}, {{x-timestamp}}, {{x-signature}}, {{token}}`}</code>
                . The collection has no pre-request script, so generate a new{" "}
                <b>x-timestamp</b> and <b>x-signature</b> for each request (valid
                for 30 seconds) and set <b>token</b> from the auth response.
              </p>
    </>
  );
}
